import { createGlobalStyle } from 'styled-components';

import colors from '../../../styles/colors';

export const Styles = createGlobalStyle`
  .colTextPrimario > span {
    color: ${colors.$brandcolor_primary_dark_green_5};
  }

  .colTextPrimario > .ant-typography {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
  }

  .rowVerMais {
    margin: 0px 10px 0px 19px;
  }
`;
